import React, { useState, useEffect } from 'react';
import './_branch-stepper.scss';

const CREATE_STEPS = [
    { key: 'info', label: '基本資訊' },
    { key: 'time', label: '營業時間' },
    { key: 'notice', label: '預約注意事項' },
    { key: 'picture', label: '分店相片' },
];

const STEP_INDEX = CREATE_STEPS.reduce((acc, s, i) => {
    acc[s.key] = i;
    return acc;
}, {});

const BranchStepper = ({ currentStep }) => {
    const [animatingStep, setAnimatingStep] = useState(null);
    const currentIndex = STEP_INDEX[currentStep] ?? 0;

    useEffect(() => {
        setAnimatingStep(currentIndex);
        const timer = setTimeout(() => setAnimatingStep(null), 600);
        return () => clearTimeout(timer);
    }, [currentIndex]);

    return (
        <div className="branch-stepper">
            {CREATE_STEPS.map((step, index) => {
                const isActive = index <= currentIndex;
                const isLastStep = index === CREATE_STEPS.length - 1;
                const isAnimating = animatingStep === index;
                const nextIndex = index + 1;
                const isConnectorAnimating = animatingStep === nextIndex;

                return (
                    <React.Fragment key={step.key}>
                        <div className={`step ${isActive ? 'active' : ''} ${isAnimating ? 'animate-in' : ''}`}>
                            <div className="step-circle">
                                {isLastStep ? '✓' : index + 1}
                            </div>
                            <div className="step-label">{step.label}</div>
                        </div>

                        {!isLastStep && (
                            <div className={`step-connector ${
                                isActive && nextIndex <= currentIndex ? 'active' : ''
                            } ${isConnectorAnimating ? 'animate-connector' : ''}`} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export { CREATE_STEPS, STEP_INDEX };
export default BranchStepper;
